module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartthings_guide_step3_img.6dfb8c9c.svg";